import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import useStyles from './styles'

const AgeGroupChip = ({ label, variant = 'junior', className }) => {
  const classes = useStyles()

  return (
    <span
      className={clsx(
        classes.chip,
        variant === 'adult' ? classes.adult : classes.junior,
        className,
      )}
    >
      {label}
    </span>
  )
}

AgeGroupChip.propTypes = {
  label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['junior', 'adult']),
  className: PropTypes.string,
}

export default AgeGroupChip
